interface Environment {
  production: boolean;
  sentryDsn: string;
  name: string;
}

export const environment: Environment = {
  production: true,
  sentryDsn: 'PLACEHOLDER_SENTRY_DNS',
  name: 'production'
};
